/* Independent homepage family gallery. No product-card or video handlers. */
(() => {
  if (customElements.get('weyz-collection-live')) return;
  class WeyzCollectionLive extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.us = false;
      this.panels = [...this.querySelectorAll('.wcl-family')];
      this.positions = new Map();
      this.strip = this.querySelector('.wcl-strip');
      this.addEventListener('click', e => this.click(e), {signal});
      this.addEventListener('keydown', e => {
        if (!e.target.closest('.wcl-gallery') || !['ArrowLeft','ArrowRight'].includes(e.key)) return;
        if (e.target.closest('.wcl-units')) return;
        e.preventDefault();
        this.showSlide(this.index + (e.key === 'ArrowRight' ? 1 : -1), true);
      }, {signal});
      this.addEventListener('touchstart', e => this.touchStart(e), {passive:true, signal});
      this.addEventListener('touchmove', e => this.touchMove(e), {passive:false, signal});
      this.addEventListener('touchend', e => this.touchEnd(e), {passive:true, signal});
      this.addEventListener('touchcancel', () => {this.gesture=null;if(this.strip)this.strip.style.scrollSnapType='';}, {passive:true, signal});
      this.querySelectorAll('.wcl-model-image').forEach(img => img.addEventListener('load', () => this.fit(), {signal}));
      this.strip?.addEventListener('scroll', () => this.updateStrip(), {passive:true, signal});
      document.addEventListener('shopify:block:select', e => {
        const block = [...this.querySelectorAll('[data-block-id]')].find(el => el.dataset.blockId === e.detail?.blockId);
        if (!block) return;
        const panel = block.closest('.wcl-family');
        this.selectFamily(panel.dataset.family);
        if (block.classList.contains('wcl-slide')) this.showSlide(this.slides.indexOf(block));
      }, {signal});
      this.resize = new ResizeObserver(() => {this.fit();this.updateStrip();});
      this.resize.observe(this);
      if (this.panels.length) this.selectFamily(this.panels[0].dataset.family);
    }
    disconnectedCallback() {
      this.events?.abort();this.events=null;
      this.resize?.disconnect();this.gesture=null;
    }
    get index() {return this.positions.get(this.active?.dataset.family) || 0;}
    selectFamily(id, productId, navigate=false) {
      const next = this.panels.find(p => p.dataset.family === id);
      if (!next) return;
      this.active = next;
      this.panels.forEach(p => {p.hidden = p !== next;});
      this.slides = [...next.querySelectorAll('.wcl-slide')];
      const matching = productId ? this.slides.findIndex(s => s.dataset.productId === productId) : -1;
      this.showSlide(matching >= 0 ? matching : this.index);
      this.querySelectorAll('[data-family-choice]').forEach(a => {a.hidden = a.dataset.familyChoice === id;});
      if (this.strip) this.strip.scrollLeft=0;
      this.updateStrip();
      if (navigate) {
        const heading = next.querySelector('.wcl-title');
        heading.focus({preventScroll:true});
        heading.scrollIntoView({behavior:this.motion(),block:'start'});
      }
    }
    showSlide(index, announce=false) {
      if (!this.active) return;
      const count = this.slides.length;
      const safe = count ? (index % count + count) % count : 0;
      this.positions.set(this.active.dataset.family, safe);
      this.slides.forEach((slide,i) => {slide.hidden=i!==safe;});
      this.active.querySelectorAll('[data-slide]').forEach((b,i) => {
        if(i===safe)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');
      });
      const current=this.slides[safe];
      this.active.querySelector('.wcl-worn').textContent=current?.dataset.worn || '';
      this.updateUnits();
      this.fit();
      if (count) {
        // Only prioritize the active photo and its neighbour; other photos stay lazy.
        [current,this.slides[(safe+1)%count]].forEach(slide => {
          const img=slide.querySelector('img');if(img)img.loading='eager';
        });
        if(announce)this.active.querySelector('[data-status]').textContent=`Photo ${safe+1} / ${count}`;
      }
    }
    updateUnits() {
      this.querySelectorAll('.wcl-units').forEach(b => b.setAttribute('aria-checked',String(this.us)));
      const info=this.active?.querySelector('[data-measurements]');
      const data=this.slides?.[this.index]?.dataset;
      if(!info || !data)return;
      const height=Number(data.height),weight=Number(data.weight);
      const validH=Number.isFinite(height)&&height>0,validW=Number.isFinite(weight)&&weight>0;
      const inches=Math.round(height/2.54);
      const h=validH ? (this.us ? `${Math.floor(inches/12)}′ ${inches%12}″` : `${(height/100).toFixed(2)} m`) : '';
      const w=validW ? (this.us ? `${Math.round(weight*2.2046226218)} lbs` : `${weight} kg`) : '';
      info.textContent=[h,w].filter(Boolean).join(' / ');
    }
    fit() {
      const slide=this.slides?.[this.index];if(!slide)return;
      const frame=this.active.querySelector('.wcl-stage'),plane=slide.querySelector('.wcl-plane'),img=plane.querySelector('img');
      const iw=img.naturalWidth || Number(img.getAttribute('width')),ih=img.naturalHeight || Number(img.getAttribute('height'));
      if(!iw || !ih || !frame.clientWidth || !frame.clientHeight)return;
      const scale=Math.min(frame.clientWidth/iw,frame.clientHeight/ih),w=iw*scale,h=ih*scale;
      Object.assign(plane.style,{inset:'auto',width:`${w}px`,height:`${h}px`,left:`${(frame.clientWidth-w)/2}px`,top:`${(frame.clientHeight-h)/2}px`});
    }
    click(e) {
      if (Date.now() < (this.suppressClickUntil || 0) && e.target.closest('.wcl-stage, .wcl-strip')) {e.preventDefault();e.stopPropagation();return;}
      const choice=e.target.closest('[data-family-choice]');
      if(choice && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && e.button===0){
        e.preventDefault();this.selectFamily(choice.dataset.familyChoice,choice.dataset.productId,true);return;
      }
      const toggle=e.target.closest('.wcl-units');
      if(toggle){this.us=!this.us;this.updateUnits();return;}
      const arrow=e.target.closest('[data-step]');
      if(arrow){this.showSlide(this.index+Number(arrow.dataset.step),true);return;}
      const dot=e.target.closest('[data-slide]');
      if(dot){this.showSlide(Number(dot.dataset.slide),true);return;}
      const scroll=e.target.closest('[data-scroll]');
      if(scroll)this.strip?.scrollBy({left:Number(scroll.dataset.scroll)*this.strip.clientWidth*.8,behavior:this.motion()});
    }
    motion(){return matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';}
    updateStrip() {
      if(!this.strip)return;
      const max=this.strip.scrollWidth-this.strip.clientWidth;
      const previous=this.querySelector('[data-scroll="-1"]'),next=this.querySelector('[data-scroll="1"]');
      previous.hidden=next.hidden=max<=2;
      previous.disabled=this.strip.scrollLeft<=2;
      next.disabled=this.strip.scrollLeft>=max-2;
    }
    touchStart(e) {
      this.suppressClickUntil=0;
      this.gesture=null;
      if(e.touches.length===1 && e.target.closest('.wcl-strip')) {
        const t=e.touches[0];this.gesture={x:t.clientX,y:t.clientY,dx:0,axis:null,strip:true,start:this.strip.scrollLeft};return;
      }
      if(e.touches.length!==1 || !e.target.closest('.wcl-stage') || e.target.closest('.wcl-units') || this.slides.length<2)return;
      const t=e.touches[0];this.gesture={x:t.clientX,y:t.clientY,dx:0,axis:null};
    }
    touchMove(e) {
      const g=this.gesture;if(!g)return;
      if(e.touches.length!==1){this.gesture=null;return;}
      const t=e.touches[0],dx=t.clientX-g.x,dy=t.clientY-g.y;
      if(!g.axis && Math.max(Math.abs(dx),Math.abs(dy))>8)g.axis=Math.abs(dx)>Math.abs(dy)*1.2?'x':'y';
      if(g.axis==='x'){
        g.dx=dx;if(e.cancelable)e.preventDefault();
        if(g.strip){this.strip.style.scrollSnapType='none';this.strip.scrollLeft=g.start-dx;}
      }
    }
    touchEnd() {
      const g=this.gesture;this.gesture=null;
      if(g?.strip)this.strip.style.scrollSnapType='';
      if(g?.axis==='x') {
        this.suppressClickUntil=Date.now()+450;
        if(!g.strip && Math.abs(g.dx)>=30)this.showSlide(this.index+(g.dx<0?1:-1),true);
      }
    }
  }
  customElements.define('weyz-collection-live',WeyzCollectionLive);
})();
